import * as Dlst from '../Constant/DLConstant';

const intialstate = {};

function GetDialysisServiceListReducer(state = {
    GetDialysisServiceListdata: intialstate,
    fetching: false,
    fetched: false,
    error: null
}, action) {
    switch (action.type) {
        case Dlst.GetDialysisService_REQ_LIST_REQUEST: { return { ...state, fetching: true, fetched: false, error: null } }
        case Dlst.GetDialysisService_REQ_LIST_FAIL: { return { ...state, fetching: false, error: action.payload, fetched: true } }
        case Dlst.GetDialysisService_REQ_LIST_SUCCESS: {
            return {
                ...state, error: null,
                fetching: false,
                fetched: true,
                GetDialysisServiceListdata: action.payload
            }
        }
        default: return state;
    }

}
function DayCareBedCategoryMSTReducer(state = {
    DayCareBedCategoryData: intialstate,
    fetching: false,
    fetched: false,
    error: null
}, action) {
    switch (action.type) {
        case Dlst.DCBEDCAT_LIST_REQUEST: { return { ...state, fetching: true, fetched: false, error: null } }
        case Dlst.DCBEDCAT_LIST_FAIL: { return { ...state, fetching: false, error: action.payload, fetched: true } }
        case Dlst.DCBEDCAT_LIST_SUCCESS: {
            return {
                ...state, error: null,
                fetching: false,
                fetched: true,
                DayCareBedCategoryData: action.payload
            }
        }
        default: return state;
    }

}
function DCAllPatientDetailsReducer(state = {
    DCAllPatientDetailsData: intialstate,
    fetching: false,
    fetched: false,
    error: null
}, action) {
    switch (action.type) {
        case Dlst.DLAllPatientDetails_LIST_REQUEST: { return { ...state, fetching: true, fetched: false, error: null } }
        case Dlst.DLAllPatientDetails_LIST_FAIL: { return { ...state, fetching: false, error: action.payload, fetched: true } }
        case Dlst.DLAllPatientDetails_LIST_SUCCESS: {
            return {
                ...state, error: null,
                fetching: false,
                fetched: true,
                DCAllPatientDetailsData: action.payload
            }
        }
        default: return state;
    }
}
function DCBedOccupiReducer(state = {
    DCBedOccupiData: intialstate,
    fetching: false,
    fetched: false,
    error: null
}, action) {
    switch (action.type) {
        case Dlst.DCBedOCCUP_LIST_REQUEST: { return { ...state, fetching: true, fetched: false, error: null } }
        case Dlst.DCBedOCCUP_LIST_FAIL: { return { ...state, fetching: false, error: action.payload, fetched: true } }
        case Dlst.DCBedOCCUP_LIST_SUCCESS: {
            return {
                ...state, error: null,
                fetching: false,
                fetched: true,
                DCBedOccupiData: action.payload
            }
        }
        default: return state;
    }

}

export {
    GetDialysisServiceListReducer, DayCareBedCategoryMSTReducer, DCAllPatientDetailsReducer, DCBedOccupiReducer
};